import type { AiPreviewScreen } from '@/features/campaigns/types/campaign';

const STATIC_SCREEN_REASON =
  'Matched your audience, location, and budget for strong reach in this area.';

export function formatDisplayDate(value: string) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function resolveSlotScreenNames(
  billboards:
    | number
    | string[]
    | Array<{
        _id?: string;
        id?: string;
        billboardId?: string;
        screenName?: string;
        billboardName?: string;
        name?: string;
      }>
    | undefined,
  nameById: Record<string, string>,
  detailNames?: string[],
  fallbackNames: string[] = [],
) {
  if (detailNames?.length) return detailNames.join(', ');

  if (billboards == null) {
    if (fallbackNames.length === 1) return fallbackNames[0];
    if (fallbackNames.length > 1) return fallbackNames.join(', ');
    return '—';
  }

  if (typeof billboards === 'number') {
    if (billboards <= 0) return '—';
    if (fallbackNames.length === 1) return fallbackNames[0];
    if (fallbackNames.length > 0 && fallbackNames.length === billboards) {
      return fallbackNames.join(', ');
    }
    if (fallbackNames.length > 0) return fallbackNames.join(', ');
    return `${billboards} screen${billboards === 1 ? '' : 's'}`;
  }

  if (!Array.isArray(billboards) || billboards.length === 0) {
    if (fallbackNames.length) return fallbackNames.join(', ');
    return '—';
  }

  const names = billboards
    .map((b) => {
      if (typeof b === 'string') return nameById[b] || b;
      const id = String(b.billboardId || b._id || b.id || '');
      return (
        b.screenName ||
        b.billboardName ||
        b.name ||
        (id ? nameById[id] : '') ||
        ''
      );
    })
    .filter(Boolean);

  if (names.length) return [...new Set(names)].join(', ');
  if (fallbackNames.length) return fallbackNames.join(', ');
  return '—';
}

export function screenReason(screen: AiPreviewScreen) {
  return (
    screen.selectionReason ||
    screen.aiReason ||
    screen.aiDescription ||
    screen.description ||
    screen.reason ||
    STATIC_SCREEN_REASON
  );
}

export function formatAvgViews(value?: number) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `${Number(value).toFixed(2)}%`;
}
